<template>
    <div
            class="address-management"
            :class="noticeList.length < 1 && page > 1 ? 'on' : ''"
            ref="container"
    >
        <div class="header acea-row row-between-wrapper user-header">
            <el-row class="user-row">
                <el-col :span="24">
                    <span style="color: #FFFFFF;font-size: larger">消息明细</span>
                </el-col>
            </el-row>
        </div>
        <div class="item" v-for="(item, index) in noticeList" :key="index">
            <div class="address">
                <div class="consignee">
                    时间：{{ item.noticeTime|formatDateDay}}
                </div>
                <div>
                    内容：{{ item.content }}
                </div>
            </div>
        </div>
        <Loading :loaded="loadend" :loading="loading"></Loading>
    </div>
</template>
<style>
    .address-management {
        background-color: #e9e9e9 !important;
        height: 100% !important;
    }

    .user-header {
        background-image: url("../../assets/images/xxzxHeader.png");
        height: 16vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
    }

    .user-row {
        width: 100%;
        margin-top: 5vh;
    }
</style>
<script type="text/babel">
    import {
        postAddress
    } from "@api/user";
    import {getNoticeList} from "@api/lesson";
    import Loading from "@components/Loading";
    import {isWeixin} from "@utils";
    import {openAddress} from "@libs/wechat";
    import {formatDate} from "@api/date.js";

    export default {
        components: {
            Loading
        },
        data() {
            return {
                page: 1,
                limit: 20,
                noticeList: [],
                loadTitle: "",
                loading: false,
                loadend: false,
                isWechat: isWeixin(),
                uid: "",
                noticeType: ""
            };
        },
        mounted: function () {
            this.uid=this.$route.query.uid
            this.noticeType=this.$route.query.noticeType
            this.queryNoticeList();
            this.$scroll(this.$refs.container, () => {
                !this.loading && this.noticeList();
            });
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd hh:mm");
            }
        },
        methods: {
            /**
             * 获取地址列表
             *
             */
            queryNoticeList: function () {
                let that = this;
                if (that.loading) return; //阻止下次请求（false可以进行请求）；
                if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
                that.loading = true;
                var param = {
                    "uid":this.uid,
                    "noticeType":this.noticeType
                }
                getNoticeList(param).then(res => {
                    console.log(res)
                    that.loading = false;
                    this.noticeList=res.noticeList
                });
            },
            getAddress() {
                openAddress().then(userInfo => {
                    this.$dialog.loading.open();
                    postAddress({
                        real_name: userInfo.userName,
                        phone: userInfo.telNumber,
                        address: {
                            province: userInfo.provinceName,
                            city: userInfo.cityName,
                            district: userInfo.countryName
                        },
                        detail: userInfo.detailInfo,
                        post_code: userInfo.postalCode,
                        type: 1,
                        wx_export: 1
                    })
                        .then(() => {
                            this.page = 1;
                            this.loading = false;
                            this.loadend = false;
                            this.noticeList = [];
                            this.AddressList();

                            this.$dialog.loading.close();
                            this.$dialog.toast({mes: "添加成功"});
                        })
                        .catch(err => {
                            this.$dialog.loading.close();
                            this.$dialog.error(err.msg || "添加失败");
                        });
                });
            }
        }
    };
</script>
